<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_PROCESANDO' | translate }}</span>
  </div>
</div>
<div *ngIf="!carInformacionInicial">
  <p-panel header="{{ 'PRODUCTO.LBL_CONFIRMARMINIMA' | translate}}">
    <form [formGroup]="formulario" (ngSubmit)="onSubmit()" novalidate id="fFormulario" name="nomFormulario">
      <div class="grid form-group">
        <div class="col-12 md:col-4 lg:col-4">
          <div class="div-form">
            <label>* {{ 'PRODUCTOREFERENCIA.LBL_TIPOVINCULACION' | translate }}</label>
            <div *ngIf="!(proVinculacionMinimoSeleccionado && proVinculacionMinimoSeleccionado.idProductoVinculacionMinimo)">
              <p-dropdown disableTab  id="idTipoVinculacion" name="nomIdTipoVinculacion" [options]="lisVinculaciones"
                          placeholder="{{ 'LBL_SELECCIONE' | translate}}" emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                          emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                          optionValue="value"
                          optionLabel="label"
                           formControlName="idTipoVinculacion" (onChange)="cargarTipoUsoCelular()"
              ></p-dropdown>
              <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idTipoVinculacion.invalid">
                {{ 'PRODUCTOREFERENCIA.LBL_TIPOVINCULACION' | translate}} {{ 'LBL_REQUERIDO' | translate}}
              </div>
            </div>
            <div *ngIf="proVinculacionMinimoSeleccionado && proVinculacionMinimoSeleccionado.idProductoVinculacionMinimo">
              <label class="falso-combo-texto">{{proVinculacionMinimoSeleccionado.nombreTipoVinculacion}}</label>
            </div>
          </div>
        </div>
        <div class="col-12 md:col-4 lg:col-4">
          <div class="div-form">
            <label>* {{ 'PRODUCTOREFERENCIA.LBL_TIPOUSOCELULAR' | translate }}</label>
            <div *ngIf="!proVinculacionMinimoSeleccionado">
              <p-dropdown disableTab  id="idTipoUsoTelefono" name="nomIdTipoUsoCelular" [options]="lisTipoUsoCelular"
                          placeholder="{{ 'LBL_SELECCIONE' | translate}}" emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                          emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                          optionValue="value"
                          optionLabel="label"
                           formControlName="idTipoUsoTelefono" (onChange)="cargarReferencias()"
              ></p-dropdown>
              <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idTipoUsoTelefono.invalid">
                {{ 'PRODUCTOREFERENCIA.LBL_TIPOUSOCELULAR' | translate}} {{ 'LBL_REQUERIDO' | translate}}
              </div>
            </div>
            <label class="falso-combo-texto"
                   *ngIf="proVinculacionMinimoSeleccionado && proVinculacionMinimoSeleccionado.idProductoVinculacionMinimo">{{proVinculacionMinimoSeleccionado.nombreTipoUsoCelular}}</label>
          </div>
        </div>
        <div class="col-12 md:col-4 lg:col-4">
          <div class="div-form">
            <label>* {{ 'PRODUCTOREFERENCIA.LBL_NATURALEZA' | translate }}</label>
            <p-multiSelect id="idTipoPersona" name="nomTipoPersona" [options]="listaTiposPersonas"
                           filter="filter"
                           defaultLabel="{{ 'LBL_SELECCIONE' | translate}}"
                           selectedItemsLabel="{0} {{ 'LBL_ITEMSELECCIONADO' | translate}}" formControlName="idNaturaleza"
                           emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                           emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                           optionValue="value"
                           optionLabel="label"
            ></p-multiSelect>
            <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idNaturaleza.invalid">
              {{ 'PRODUCTOREFERENCIA.LBL_NATURALEZA' | translate}} {{ 'LBL_REQUERIDO' | translate}}
            </div>
          </div>
        </div>
      </div>
      <div class="grid form-group">
        <div class="col-12 md:col-6 lg:col-6">
          <div class="div-form">
            <label>*{{ 'PRODUCTOREFERENCIA.LBL_REFERENCIAS' | translate }}</label>
            <p-multiSelect id="idTipoReferencia" name="nomIdTipoReferencia" [options]="lisReferencias"
                           defaultLabel="{{ 'LBL_SELECCIONE' | translate}}"
                           selectedItemsLabel="{0} {{ 'LBL_ELEMENTOSSELECCIONADOS' | translate}}"
                           formControlName="idTipoReferencia"
                           emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                           emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                           optionValue="value"
                           optionLabel="label"
            ></p-multiSelect>
            <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idTipoReferencia.invalid">
              {{ 'PRODUCTOREFERENCIA.LBL_REFERENCIAS' | translate}} {{ 'LBL_REQUERIDO' | translate}}
            </div>
          </div>
        </div>
        <div class="col-12 md:col-6 lg:col-6">
          <div class="div-form">
            <label>* {{ 'PRODUCTOREFERENCIA.LBL_NUMREFMIN' | translate }}</label>
            <input type="text" pInputText id="idNroReferencias"
                   name="nomNroReferencias"
                   autocomplete="off"
                   formControlName="nroReferencias"
                   numero-entero-reactive
                   [maxlength]="3" [minimo]="1"

            >
            <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.nroReferencias.invalid">
              {{ 'PRODUCTOREFERENCIA.LBL_NUMREFMIN' | translate}} {{ 'LBL_REQUERIDO' | translate}}
            </div>
          </div>
        </div>
      </div>

      <div class="grid form-group">
        <div class="col-12" style="display: flex">
          <div class="col-6 md:col-3 lg:col-3">
            <p-checkbox label="{{ 'PRODUCTOREFERENCIA.LBL_ANALIZAMOS' | translate}}" binary="true"
                        id="indicadorCanalAnalizamos"
                        name="nomindicadorCanalAnalizamos"
                        formControlName="indicadorCanalAnalizamos"></p-checkbox>
          </div>
          <div class="col-6 md:col-3 lg:col-3">
            <p-checkbox label="{{ 'PRODUCTOREFERENCIA.LBL_DIGITAL' | translate}}" binary="true"
                        id="indicadorCanalDigital"
                        name="nomindicadorCanalDigital"
                        formControlName="indicadorCanalDigital"></p-checkbox>
          </div>
        </div>
      </div>


      <div class="grid form-footer-buttons">
        <div class="form-group col-12">
          <div *ngIf="!guardando">
            <a (click)="regresar(formulario.dirty)" class="cancelar">{{'BTN_CANCELAR' | translate }}</a>
            <button class="p-button-datatables" icon="fa fa-plus"
                    label="{{(proVinculacionMinimoSeleccionado && proVinculacionMinimoSeleccionado.idProductoVinculacionMinimo)
                    ?('BTN_ACTUALIZAR' | translate):('BTN_AGREGAR' | translate) }}"
                    type="submit"
                    pButton></button>
          </div>
          <div *ngIf="guardando">
            <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
            <span>{{'LBL_GUARDANDO' | translate }}</span>
          </div>
        </div>
      </div>

    </form>
    <div class="grid">
      <div class="col-12 md:col-6 lg:col-6">
      </div>
      <div class="col-12 md:col-6 lg:col-6">
        <input #gb type="text" pInputText size="40" placeholder="{{ 'LBL_BUSCAR' | translate }}"
               (input)="dt.filterGlobal($event.target.value, 'contains')"
               [(ngModel)]="busqueda" (change)="setBusqueda()">
      </div>
    </div>
    <div class="grid">
      <div class="col-12 md:col-12 lg:col-12">
        <p-table [columns]="columnas" [loading]="carTabla" #dt
                 [value]="proVinculacionesMinimasHabilitados" selectionMode="single" dataKey="idProductoConfirmacionVinculacion"
                 [paginator]="true" [rows]="10"  paginatorPosition="bottom">
          <ng-template pTemplate="header" let-columns>
            <tr>
              <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
                {{col.header}}
                <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-row>
            <tr [pSelectableRow]="row">
              <td>{{row.nombreTipoUsoCelular}}</td>
              <td>{{row.nombreTipoVinculacion}}</td>
              <td>{{row.tipoPersona}}</td>
              <td>{{row.nombresReferencias}}</td>
              <td class="text-center">
                <p-checkbox [(ngModel)]="row.indicadorCanalAnalizamos" binary="true" disabled="true"></p-checkbox>
              </td>
              <td class="text-center">
                <p-checkbox [(ngModel)]="row.indicadorCanalDigital" binary="true" disabled="true"></p-checkbox>
              </td>
              <td>{{row.nroReferencias}}</td>
              <td class="text-center">
                <div class="btn-group" role="group">
                  <button type="button" class="p-button p-button-success btn" icon="fa fa-pencil" data-toggle="tooltip"
                          title="{{'BTN_EDITAR' | translate}}" pButton *ngIf="!guardando"
                          (click)="editar(row)"></button>
                  <button type="button" class="p-button p-button-success btn" icon="fa fa-trash" data-toggle="tooltip"
                          title="{{'BTN_INHABILITAR' | translate}}" pButton
                          (click)="inhabilitar(row)"></button>
                  <fieldset *ngIf="guardando">
                    <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
                    <span>{{'LBL_GUARDANDO' | translate }}</span>
                  </fieldset>
                </div>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage" let-columns>
            <tr>
              <td [attr.colspan]="columns.length">
                {{ 'MSG_NOHAYREGISTROS' | translate}}
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </p-panel>
</div>


<p-confirmDialog #cd key="referencias-minima">
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>
